import axios from "@lib/axios";

export async function like(productId) {
  const res = await axios.post(`products/${productId}/like`).catch();
  return res.data.liked_products_ids;
}

export async function dislike(productId) {
  const res = await axios.delete(`products/${productId}/like`).catch();
  return res.data.liked_products_ids;
}

export async function getProducts(context, queryString) {
  const res = await axios.get(`catalog/${context}?${queryString}`);
  return res.data;
}

export async function getProduct(slug, locale) {
  const url = `catalog/swap/${slug}`;
  const res = await axios.get(url, {
    headers: { Language: locale },
  });
  return res.data.data;
}

export async function getProductSuggestions(productSlug, { min, max } = {}) {
  let url = `catalog/similar?slug=${productSlug}`;
  if (min != null) url += `&min_results=${min}`;
  if (max != null) url += `&max_results=${max}`;
  const res = await axios.get(url);
  return res.data;
}

export async function getProductVariants(productSlug) {
  const res = await axios.get(`products/${productSlug}/variants`);
  return res.data;
}
